import React, { createContext, useContext, useState } from 'react'
import { Dialog, Classes } from '@blueprintjs/core'

const InstructionsDialogContext = createContext()

export default function InstructionsDialogProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const [content, setContent] = useState(null)
  const [title, setTitle] = useState(null)

  const value = {
    openDialog: (newContent, newTitle = null) => {
      setContent(newContent)
      setTitle(newTitle)
      setIsOpen(true)
    },
    closeDialog: () => {
      setIsOpen(false)
      setContent(null)
      setTitle(null)
    },
  }

  return (
    <InstructionsDialogContext.Provider value={value}>
      {children}

      {/* The Dialog with Instructions */}
      <Dialog
        icon="info-sign"
        title={title || 'Instructions'}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        canOutsideClickClose={true}
        canEscapeKeyClose={true}
        style={{
          width: '95vw',
          maxWidth: '1600px',
          height: 'auto',
          maxHeight: '95vh'
        }}
      >
        <div className={Classes.DIALOG_BODY} style={{ overflow: 'auto' }}>
          {content}
        </div>
      </Dialog>
    </InstructionsDialogContext.Provider>
  )
}

export function useInstructionsDialog() {
  const context = useContext(InstructionsDialogContext)
  if (!context) {
    throw new Error(
      `useInstructionsDialog must be used within a InstructionsDialogProvider`
    )
  }
  return context
}
